import eatingCakeLandscapeImg from "../../../assets/img/cake-landscape.png"
import eatingCakeLandscapeImgWebp from "../../../assets/img/cake-landscape.webp"

const EnjoyingCake = () => (
    <section id="enjoying-cake">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-4">
                <div className="col-xxl-8 col-lg-10 col-11 px-xxl-4 px-3 ">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={eatingCakeLandscapeImgWebp} type="image/webp" />
                             <img className="img-fluid gg-border-radius" src={eatingCakeLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center">
                            <p>
                                And not picking at it either, like most of us do when we want to pretend we’re being "good."<br />
                                <b className="fs-5 lh-1">She was <i>enjoying</i> it.</b>
                            </p>
                            <p>
                                I stood there, stunned.<br />
                                For a second, I wondered if she had been misdiagnosed all those years ago.<br />
                                But no…<br />
                                Alice still had type 2 diabetes.
                            </p>
                            <p>
                                That moment cracked something open in me.<br />
                                <b>I had to know what had changed for her.</b>
                            </p>
                            <p>
                                And following that curiosity…<br />
                                <b>Led me to meet the man who would quietly, completely, shift the course of my life.</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default EnjoyingCake;